<template>
  <div class="h-100">
    <calendar v-on:updateActiveDate="setActiveDate" :events="workoutLogs" :user="userProfile"></calendar>
    <v-layout v-show="!currentLog && !loading" row wrap align-center fill-height style="padding-bottom: 56px;">
      <v-flex xs12>
        <div class="text-xs-center" style="margin-top: 16px;">
        <h3 class="heading">Ready to Workout?</h3>
        <p>
          Click below to view or start your workout.
        </p>
        </div>
      </v-flex>
      <v-flex v-for="(workout, index) in activeWorkouts" v-if="activeWorkouts.length > 0" :key="'workout' + index" xs12>
        <v-list>
         <v-list-tile
           avatar
           @click="goTo(workout)"
         >
           <v-list-tile-action>
             <v-icon color="secondary">fitness_center</v-icon>
           </v-list-tile-action>

           <v-list-tile-content>
             <v-list-tile-title v-text="workout.title"></v-list-tile-title>
           </v-list-tile-content>

           <v-list-tile-avatar>
             <v-icon color="secondary">keyboard_arrow_right</v-icon>
           </v-list-tile-avatar>
         </v-list-tile>
        </v-list>
      </v-flex>
      <v-flex v-if="activeWorkouts.length === 0" xs12>
        <p class="text-xs-center">
         <strong class="primary--text">
            We are currently working on you workout schedule.<br> Please check back soon.
         </strong>
        </p>
      </v-flex>
    </v-layout>
    <v-layout v-show="currentLog && !loading" row wrap align-start fill-height>
      <v-flex xs12>
        <v-subheader>Workout Log</v-subheader>
          <v-list v-for="(log, index) in currentLog" :key="index" v-if="index !== 'created_at' && index !== 'user_id' && index !== 'sessionTll' && index !== 'workout_id'" three-line style="margin-bottom: 8px;">
          <v-list-tile>
            <v-list-tile-content v-for="(exercise, index) in exercises" :key="index" v-if="exercise.exercise_id === log.exercise_id">
              <v-list-tile-title class="primary--text">{{exercise.name}}</v-list-tile-title>
              <v-list-tile-sub-title>
                Set1: {{log.set1 | displayWeight | weight}} | Set2: {{log.set2 | displayWeight | weight}} | Set3: {{log.set3 | displayWeight | weight}} | Set4: {{log.set4 | displayWeight | weight}}
              </v-list-tile-sub-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
      </v-flex>
    </v-layout>
    <v-layout v-show="loading" fill-height>
      <v-flex xs12>
        <v-progress-circular
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-flex>
    </v-layout>

  </div>
</template>
<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import { db } from '@/services/firebase'
import calendar from '@/components/partial/calendar-buttons.vue'
export default {
  components: {
    calendar
  },
  data () {
    return {
      workouts: [],
      exercises: [],
      workoutLogs: [],
      dialog: false,
      loading: false,
      dateContext: moment().startOf('day').unix()
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.getWorkouts()
      this.getExercises()
      this.getWorkoutLogs()
    })
  },
  methods: {
    setActiveDate: function (date) {
      this.dateContext = moment(date).startOf('day').unix()
    },
    getWorkouts: function () {
      var self = this
      self.loading = true
      db.collection('user_workouts')
        .where('user_id', '==', self.currentUser)
        .where('phase', '==', self.userProfile.phase)
        .orderBy('created_at', 'desc')
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var data = doc.data()
            data.id = doc.id
            self.workouts.push(data)
          })
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
      self.loading = false
    },
    getExercises: function () {
      const self = this
      db.collection('exercises')
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var newExercise = doc.data()
            self.$set(newExercise, 'exercise_id', doc.id)
            self.exercises.push(newExercise)
          })
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    getWorkoutLogs: function () {
      var self = this
      db.collection('workout_logs').where('user_id', '==', self.currentUser)
        .get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            var newLog = doc.data()
            self.workoutLogs.push(newLog)
          })
        })
        .catch(function (error) {
          console.log('Error getting workouts: ', error)
        })
    },
    goTo: function (workout) {
      this.$router.push({name: 'Log workout', params: {workoutId: workout.id, workout: workout, selectedDate: this.dateContext}})
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'currentUser',
      userProfile: 'userProfile'
    }),
    activeWorkouts: function () {
      var self = this
      var currentDay = moment().endOf('day')
      var filtered = []
      if (self.userProfile.fresh) {
        filtered = self.workouts.filter(function (workout) {
          return workout.phase === self.userProfile.phase
        })
      } else {
        filtered = self.workouts.filter(function (workout) {
          if (workout.end) {
            var end = moment.unix(workout.end).endOf('day')
            return moment(currentDay).isSameOrBefore(end)
          } else {
            return workout
          }
        })
      }
      if (filtered.length > 0) {
        return filtered
      } else {
        return []
      }
    },
    currentLog: function () {
      var self = this
      var filtered = self.workoutLogs.filter(function (workout) {
        var dateString = moment.unix(self.dateContext)
        return moment.unix(workout.created_at).isSame(dateString, 'day')
      })
      if (filtered.length > 0) {
        if (Array.isArray(filtered)) {
          return filtered[filtered.length - 1]
        } else {
          return filtered
        }
      } else {
        return null
      }
    }
  }
}
</script>
<style scoped>
  /* #workout-list .v-icon:nth-of-type(odd){

  } */
</style>



// WEBPACK FOOTER //
// src/components/members/workoutsView.vue